import { atom } from "recoil";

import { TComp } from "MVVM/Views/Competitions/@types";
import { persistAtom } from ".";

export const ActiveCampaign = atom({
  key: "ActiveCampaign_V0.1",
  default: {} as Partial<TComp>,
});

export const SubmittedClips = atom<string[]>({
  key: "SubmittedClips_V0.1",
  default: [],
  effects_UNSTABLE: [persistAtom],
});
